import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../lib/api";
import BottomNav from "../components/BottomNav";
import { Heart, MessageCircle } from "lucide-react";

export default function Matches() {
  const [list, setList] = useState(null);
  useEffect(() => {
    (async () => {
      try { const { data } = await api.get("/matches"); setList(data); }
      catch { setList([]); }
    })();
  }, []);
  return (
    <div className="app-shell bg-aurora min-h-screen pb-nav" data-testid="matches-page">
      <div className="px-6 pt-10 pb-5">
        <p className="text-xs uppercase tracking-widest text-[#082A24] font-medium">Tvé spojení 💕</p>
        <h1 className="font-display text-3xl text-[#332D38]">Matche</h1>
      </div>
      <div className="px-6 space-y-3">
        {list === null && [...Array(3)].map((_, i) => <div key={i} className="h-20 rounded-3xl shimmer" />)}
        {list?.length === 0 && (
          <div className="glass-card p-10 text-center text-[#8A7E91]" data-testid="no-matches">
            <Heart size={36} className="mx-auto mb-3 text-[#8FA09C]" strokeWidth={1.5} />
            <p>Zatím žádné matche.<br />Vrať se na <Link to="/discover" className="text-[#C9A66B] font-medium">Objevuj</Link> a najdi své spojení ✨</p>
          </div>
        )}
        {list?.map((m) => (
          <Link key={m.match_id} to={`/chat/${m.match_id}`} data-testid={`match-${m.match_id}`}>
            <div className="glass-card p-4 flex items-center gap-4 active:scale-[0.98] transition">
              <div className="w-14 h-14 rounded-2xl overflow-hidden bg-gradient-to-br from-[#DEE7E2] to-[#DEE7E2] flex items-center justify-center shrink-0">
                {m.user.photo_url ? <img src={m.user.photo_url} alt={m.user.name} className="w-full h-full object-cover" /> : <Heart className="text-white" />}
              </div>
              <div className="flex-1 min-w-0">
                <p className="font-display text-lg text-[#332D38]">{m.user.name}, {m.user.age}</p>
                <p className="text-xs text-[#8A7E91] truncate">{m.last_message?.text || "Napiš první zprávu ✨"}</p>
              </div>
              <MessageCircle size={20} className="text-[#5F7F77] shrink-0" strokeWidth={1.7} />
            </div>
          </Link>
        ))}
      </div>
      <BottomNav />
    </div>
  );
}
